import { ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next'

import CardClassDesigner from 'adminDashboard/benefitDetails/common/ProductClassSummaryWrapper'

import { ProductIds } from 'core'
import OrderedPageFilter from 'core/application/commons/orderedPageFilter'
import { PagedProductEligibleEmployee } from 'core/application/csiDashboard/csiSearch/getProductEligibleEmployees'
import { ProductClass } from 'core/domain/benefit/productClass'

import './ClassesSummary.less'

interface ClassesSummaryProps {
  id: string
  title: string
  loadDataAfterRender?: boolean
  apiEndpoint: (id: string) => Promise<ProductClass>
  eligibleEmployeesEndpoint?: (filter: OrderedPageFilter, id: string) => Promise<PagedProductEligibleEmployee>
  item: { name: string; id: string; totalEmployeesAssigned?: number }
  getClassSummary: (
    item: ProductClass | null,
    employees: PagedProductEligibleEmployee | null,
    translate: (key: string) => string,
    setEmployeesFilter: (values: OrderedPageFilter) => void,
    productId: ProductIds,
  ) => ReactNode
  productId: ProductIds
}

const defaultFilter = {
  pageNumber: 1,
  pageSize: 10,
  orderColumn: 'fullName',
  orderDescending: false,
}

const ClassSummary = (props: ClassesSummaryProps) => {
  const { t: translate } = useTranslation()
  const [employeesFilter, setEmployeesFilter] = useState<OrderedPageFilter>(defaultFilter)

  return (
    <CardClassDesigner
      title={props.title}
      id={props.item.id}
      designSummary={(productClass, productEligibleEmployee) => {
        return props.getClassSummary(
          productClass,
          productEligibleEmployee,
          translate,
          setEmployeesFilter,
          props.productId,
        )
      }}
      loadDataAfterRender={props.loadDataAfterRender}
      apiEndpoint={props.apiEndpoint}
      eligibleEmployeesEndpoint={props.eligibleEmployeesEndpoint}
      employeesFilter={employeesFilter}
    />
  )
}

export default ClassSummary
